














import { Component, Prop, Vue } from 'vue-property-decorator';
import DatePickerVue from '@/common/DatePickerVue.vue';

@Component({components: { DatePickerVue }})
export default class DatePickerTh extends Vue {

  get dateToSubmit() {
    return DatePickerTh.convertDateToLocal(this.selectedDate);
  }

  private static convertDateToLocal(date: Date): string {
    return date.toLocaleDateString('de-AT', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(/\u200E/g, '');
  }

  @Prop({required: true})
  public localFormName: string;

  @Prop({required: true})
  public localName: string;

  @Prop({required: false})
  public localSelectedDate: string | null;

  public selectedDate = new Date();

  public mounted() {
    this.selectedDate = new Date();
    if (this.localSelectedDate) {
      this.selectedDate = new Date(this.localSelectedDate);
    }
  }
}
